/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamExamitemidPreviewQueryResponse,
  GetApiV1ExamExamitemidPreviewPathParams,
  GetApiV1ExamExamitemidPreview401,
  GetApiV1ExamExamitemidPreview404,
  GetApiV1ExamExamitemidPreview500,
} from "../../types/examQuestionLibraryController/GetApiV1ExamExamitemidPreview.ts";

function getGetApiV1ExamExamitemidPreviewUrl(
  examItemId: GetApiV1ExamExamitemidPreviewPathParams["examItemId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/exam/${examItemId}/preview` as const,
  };
  return res;
}

/**
 * @description Retorna os dados de pré-visualização de uma questão da biblioteca, incluindo tipo do componente, rótulo, informações e, quando aplicável, as opções da lista de respostas. **(Requer Authorization para autenticação)**
 * @summary Pré-visualizar questão da biblioteca (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:examItemId/preview}
 */
export async function getApiV1ExamExamitemidPreview(
  examItemId: GetApiV1ExamExamitemidPreviewPathParams["examItemId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamExamitemidPreviewQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamExamitemidPreview401
      | GetApiV1ExamExamitemidPreview404
      | GetApiV1ExamExamitemidPreview500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamExamitemidPreviewUrl(examItemId).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
